import React from "react"
import { Box, Switch, Typography } from "@mui/material"
import { dsColorNew } from "@palette"
import { AppTiersAutocomplete } from "@components/Autocomplete"
import { BACKEND_APIS } from "@constants"
import useDsRepricingDataInfo from "Pages/DsRepricing/Page/@hooks/useDataInfo"
import { dsRepricingDrawerData, dsRepricingOriginalData } from "Pages/DsRepricing/Page/@signals"
import { enrichFilterIds } from "Pages/DsRepricing/Page/@utils/filterEnrich"

export default function DsRepricingExcludeProviders() {
	const d = dsRepricingDrawerData.peek()
	const { dataInfo: idsInfo, setDataInfo: setIds } = useDsRepricingDataInfo(d.filterGroupProviders ?? [])
	const { dataInfo: exclInfo, setDataInfo: setExcl } = useDsRepricingDataInfo(d.filterGroupProvidersExclusion ?? false)

	const isExclusion = exclInfo.value
	const ids = idsInfo.value ?? []

	const updateMode = (checked) => setExcl(checked, 'filterGroupProvidersExclusion')
	const updateIds = (_, opts) => setIds(opts ?? [], 'filterGroupProviders')

	return (
		<Box>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
				<Switch checked={isExclusion} onChange={e => updateMode(e.target.checked)} size="small"/>
				<Typography sx={{ fontSize: 14, color: dsColorNew.textDark, fontWeight: 500 }}>
					{isExclusion ? 'Exclude tiers' : 'Include tiers'}
				</Typography>
			</Box>
			<AppTiersAutocomplete
				multiple
				urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/tiersV2`}
				label="Tiers"
				placeholder={isExclusion ? 'All tiers except…' : 'All tiers'}
				value={ids.map(o => o?.value ?? o)}
				onChange={updateIds}
				onAjax={options => { enrichFilterIds('filterGroupProviders', options, dsRepricingDrawerData, dsRepricingOriginalData); return options }}
			/>
		</Box>
	)
}